export const videoSeminarsData = [
    {
        id: 1,
        speaker: 'Тыныкулов Ерден',
        topic: 'Анализ исходного кода',
        info: '2,5 млн просмотров • 6 месяцев назад'
    },
    {
        id: 2,
        speaker: 'Бунаков Вадим',
        topic: 'Функции информационной безопасности',
        info: '1 млн просмотров • 5 месяцев назад'
    },
    {
        id: 3,
        speaker: 'Бажаев Нуржан',
        topic: 'Нагрузочное испытание',
        info: '1 млн просмотров • 4 месяца назад'
    },
    {
        id: 4,
        speaker: 'Ешмухаметов Ерлан',
        topic: 'Обследование сетевой инфраструктуры',
        info: '1 млн просмотров • 3 месяца назад'
    },
    {
        id: 5,
        speaker: 'Смагулов Асылан',
        topic: 'Обследование процессов обеспечения информационной безопасности',
        info: '2,5 млн просмотров • 2 месяца назад'
    },
    {
        id: 6,
        speaker: 'Сейдазимов Нургали',
        topic: 'Интернет-портал SYNAQ',
        info: '1 млн просмотров • 28 дней назад'
    }
]
